// source: starlord/messages/response/multi_application_response.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var starlord_messages_models_application_details_pb = require('../../../starlord/messages/models/application_details_pb.js');
goog.object.extend(proto, starlord_messages_models_application_details_pb);
goog.exportSymbol('proto.MultiApplicationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MultiApplicationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.MultiApplicationResponse.repeatedFields_, null);
};
goog.inherits(proto.MultiApplicationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.MultiApplicationResponse.displayName = 'proto.MultiApplicationResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.MultiApplicationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MultiApplicationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.MultiApplicationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MultiApplicationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MultiApplicationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationdetailsList: jspb.Message.toObjectList(msg.getApplicationdetailsList(),
    starlord_messages_models_application_details_pb.ApplicationDetails.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MultiApplicationResponse}
 */
proto.MultiApplicationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MultiApplicationResponse;
  return proto.MultiApplicationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MultiApplicationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MultiApplicationResponse}
 */
proto.MultiApplicationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new starlord_messages_models_application_details_pb.ApplicationDetails;
      reader.readMessage(value,starlord_messages_models_application_details_pb.ApplicationDetails.deserializeBinaryFromReader);
      msg.addApplicationdetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MultiApplicationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MultiApplicationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MultiApplicationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MultiApplicationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationdetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      starlord_messages_models_application_details_pb.ApplicationDetails.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ApplicationDetails applicationDetails = 1;
 * @return {!Array<!proto.ApplicationDetails>}
 */
proto.MultiApplicationResponse.prototype.getApplicationdetailsList = function() {
  return /** @type{!Array<!proto.ApplicationDetails>} */ (
    jspb.Message.getRepeatedWrapperField(this, starlord_messages_models_application_details_pb.ApplicationDetails, 1));
};


/**
 * @param {!Array<!proto.ApplicationDetails>} value
 * @return {!proto.MultiApplicationResponse} returns this
*/
proto.MultiApplicationResponse.prototype.setApplicationdetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ApplicationDetails=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ApplicationDetails}
 */
proto.MultiApplicationResponse.prototype.addApplicationdetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ApplicationDetails, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.MultiApplicationResponse} returns this
 */
proto.MultiApplicationResponse.prototype.clearApplicationdetailsList = function() {
  return this.setApplicationdetailsList([]);
};


goog.object.extend(exports, proto);
